export const ITEMS_LIMIT = 20

export default { ITEMS_LIMIT }
